import { create } from 'zustand'
import type { MobileHeaderAction } from '@/components/layout/MobileHeader/MobileHeader.types'

interface MobileHeaderStore {
  actions:       MobileHeaderAction[]
  backAction:    (() => void) | null
  hideBottomNav: boolean
  set:           (config: { actions?: MobileHeaderAction[]; backAction?: (() => void) | null; hideBottomNav?: boolean }) => void
  clear:         () => void
}

export const useMobileHeaderStore = create<MobileHeaderStore>(set => ({
  actions:       [],
  backAction:    null,
  hideBottomNav: false,
  set: config => set(state => ({
    actions:       config.actions       !== undefined ? config.actions.slice(0, 2) : state.actions,
    backAction:    config.backAction    !== undefined ? config.backAction           : state.backAction,
    hideBottomNav: config.hideBottomNav !== undefined ? config.hideBottomNav        : state.hideBottomNav,
  })),
  clear: () => set({ actions: [], backAction: null, hideBottomNav: false }),
}))
